<template>
  <router-view />
</template>

<script>
export default {
  name: "codeprint",
};
</script>